import React from 'react';
import PropTypes from 'prop-types';
import AccessMethodsSettings from '../settings/AccessMethodsSettings';
import EnhancedRaisedButton from 'components/button/EnhancedRaisedButton';
import MenuItem from 'material-ui/MenuItem';
import RenderCheckBoxInputField from 'components/form/InputFields/RenderCheckBoxInputField';
import RenderSelectInputField from 'components/form/InputFields/RenderSelectInputField';
import Row from 'components/list/Filters/layout/Row';
import accessMethodsHelper from 'helpers/accessMethodsHelper';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Section } from 'components/ui/table/elements';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

class AccessMethodCreate extends React.Component {
    submit = (values) => {
        const {
            handleSubmitForm,
            id,
        } = this.props;

        if (utils.isEmpty(values)) {
            return null;
        }

        values = Object.assign({}, values, {
            access_point_id: id,
        });

        return handleSubmitForm(values);
    }

    render() {
        const {
            handleSubmit,
            selected_method,
            submitting,
            translate,
        } = this.props;

        const directions = accessMethodsHelper.getDirectionIDs(selected_method);
        const accessMethods = accessMethodsHelper.getAccessMethods();
        const settings = accessMethodsHelper.getSettings(selected_method);

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(this.submit.bind(this)) }>

                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    name='access_direction'
                                    choices={ directions }
                                    component={ RenderSelectInputField }
                                    fullWidth={ false }
                                    label={ translate('resources.access_methods.fields.direction') }
                                    validate={ validations.required }
                                >
                                    {
                                        directions.map((direction) => {
                                            return (
                                                <MenuItem
                                                    key={ `direction-${ direction }` }
                                                    primaryText={ translate(`resources.access_methods.list.directions.${ direction }`) }
                                                    value={ direction }
                                                />
                                            );
                                        })
                                    }
                                </Field>

                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderCheckBoxInputField }
                                    label={ translate('resources.access_methods.fields.enabled') }
                                    type='checkbox'
                                    name='enabled'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    name='access_method_id'
                                    component={ RenderSelectInputField }
                                    fullWidth={ false }
                                    label={ translate('resources.access_methods.fields.name') }
                                    validate={ validations.required }
                                >
                                    {
                                        utils.map(accessMethods, (name, key) => {
                                            return (
                                                <MenuItem
                                                    key={ `method-${ key }` }
                                                    primaryText={ name }
                                                    value={ parseInt(key, 10) }
                                                />
                                            );
                                        })
                                    }
                                </Field>
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderCheckBoxInputField }
                                    label={ translate('resources.access_methods.fields.is_allowed_for_users') }
                                    type='checkbox'
                                    name='is_allowed_for_users'
                                    source='is_allowed_for_users'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <AccessMethodsSettings settings={ settings } />

                    <Section>
                        <ButtonWrapper>
                            <EnhancedRaisedButton
                                label={ translate('actions.submit') }
                                type='submit'
                                loading={ submitting }
                                disabled={ submitting }
                                primary
                            />
                        </ButtonWrapper>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

AccessMethodCreate.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    selected_method: PropTypes.number,
    submitting: PropTypes.bool,
    translate: PropTypes.func,
};

const selector = formValueSelector('access_methods_create');

const mapStateToProps = (state) => {
    return {
        selected_method: selector(state, 'access_method_id'),
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        null,
    ),
    translate,
    reduxForm(),
);

export default enhance(AccessMethodCreate);



// WEBPACK FOOTER //
// ./src/pages/accessPoints/access-methods/create/AccessMethodCreate.js